export default __webpack_public_path__ + "static/sentinel-agc-8b3e37ff86436097e35a5b164c513f2d.jpg";